



































import { Component, Vue } from "vue-property-decorator";
import BlogPost from "./BlogPost.vue";
import { getMagazinePosts } from "@/classes/TayehApi/Mag";

@Component({
  components: {
    BlogPost,
  },
})
export default class Blog extends Vue {
  BPosts: any[] = [];
  failed = false;
  async getBPosts(): Promise<void> {
    try {
      const res = await getMagazinePosts({
        _start: 0,
        _limit: 4,
        _sort: "updated_at:DESC",
      });
      this.BPosts = res.data;
    } catch {
      this.failed = true;
    }
  }

  get page_loaded(): boolean {
    return document.readyState == "complete";
  }

  mounted() {
    this.getBPosts();
  }
}
